import { MasterDataApiService } from 'Services/ApiServices';
import { shouldFetchData } from 'Helpers/ReduxHelper';
import { normalizeApiResponse } from 'Helpers/ApiHelpers';
import F2WCustomLogger from 'Services/F2WCustomLogger';
import {
  GET_SEASONS_SUCCESS,
  GET_COUNTRIES_SUCCESS,
  GET_REGIONS_SUCCESS,
  GET_DESTINATIONS_SUCCESS,
} from 'Constants/MasterDataConstants';

export function getSeasons() {
  const getSeasonsSuccess = (seasons) => {
    return {
      type: GET_SEASONS_SUCCESS,
      data: { seasons },
    };
  };

  return async function (dispatch, getState) {
    const { masterData } = getState();
    if (!shouldFetchData(masterData?.seasons)) return;

    try {
      const response = await MasterDataApiService.getSeasons();
      const { data: responseData } = normalizeApiResponse(response);
      const data = responseData?.masterDataList || [];
      dispatch(getSeasonsSuccess(data));
    } catch (error) {
      F2WCustomLogger.error('Error fetching seasons', error, { action: 'getSeasons' });
      dispatch(getSeasonsSuccess([]));
    }
  };
}

export function getCountries() {
  const getCountriesSuccess = (countries) => {
    return {
      type: GET_COUNTRIES_SUCCESS,
      data: { countries },
    };
  };

  return async function (dispatch, getState) {
    const { masterData } = getState();
    if (!shouldFetchData(masterData?.countries)) return;

    try {
      const response = await MasterDataApiService.getCountries();
      const { data: responseData } = normalizeApiResponse(response);
      const data = responseData?.masterDataList || [];
      dispatch(getCountriesSuccess(data));
    } catch (error) {
      F2WCustomLogger.error('Error fetching countries', error, { action: 'getCountries' });
      dispatch(getCountriesSuccess([]));
    }
  };
}

export function getRegions() {
  const getRegionsSuccess = (regions) => {
    return {
      type: GET_REGIONS_SUCCESS,
      data: { regions },
    };
  };

  return async function (dispatch, getState) {
    const { masterData } = getState();
    if (!shouldFetchData(masterData?.regions)) return;

    try {
      const response = await MasterDataApiService.getRegions();
      const { data: responseData } = normalizeApiResponse(response);
      const data = responseData?.masterDataList || [];
      dispatch(getRegionsSuccess(data));
    } catch (error) {
      F2WCustomLogger.error('Error fetching regions', error, { action: 'getRegions' });
      dispatch(getRegionsSuccess([]));
    }
  };
}

export function getDestinations() {
  const getDestinationsSuccess = (destinations) => {
    return {
      type: GET_DESTINATIONS_SUCCESS,
      data: { destinations },
    };
  };

  return async function (dispatch, getState) {
    const { masterData } = getState();
    if (!shouldFetchData(masterData?.destinations)) return;

    try {
      const response = await MasterDataApiService.getDestinations();
      const { data: responseData } = normalizeApiResponse(response);
      const data = responseData?.masterDataList || [];
      const destinationsWithHanover = [...data, { label: 'Hanover', value: 'Hanover' }];
      dispatch(getDestinationsSuccess(destinationsWithHanover));
    } catch (error) {
      F2WCustomLogger.error('Error fetching destinations', error, { action: 'getDestinations' });
      dispatch(getDestinationsSuccess([]));
    }
  };
}
